import(/* webpackMode: "eager" */ "/app/components/Advertising.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/Footer.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/layout/Header.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/partials/Container.js");
;
import(/* webpackMode: "eager" */ "/app/components/partials/ContentBox.js");
;
import(/* webpackMode: "eager" */ "/app/components/partials/Helpers.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/widgets/CoinCotation.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/widgets/Talk2Us.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/widgets/Weather.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/image/image.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/stack/stack.js");
;
import(/* webpackMode: "eager", webpackExports: ["StatusIndicator","StatusPropsProvider","StatusRoot"] */ "/app/node_modules/@chakra-ui/react/dist/esm/components/status/status.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/heading.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
